import { render, staticRenderFns } from "./social-info_h5.vue?vue&type=template&id=0b7fb47c&scoped=true&"
import script from "./social-info_h5.vue?vue&type=script&lang=js&"
export * from "./social-info_h5.vue?vue&type=script&lang=js&"
import style0 from "./social-info_h5.vue?vue&type=style&index=0&id=0b7fb47c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fb47c",
  null
  
)

export default component.exports